import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Slide from "../slide.js";
import SUPER_GUC_IMG from "../img/SUPER_GUC.png";
import Introduction_img from "../img/inrtoduction_image.png";
import Sub_cohorts_img from "../img/sub-cohorts.png";
import Crow_img_1 from "../img/Crow/3.png";
import Crow_img_2 from "../img/Crow/4.png";
import Crow_img_3 from "../img/Crow/5.png";
const Left_div = styled.div`
    display : inline-block; 
    width : 50%;
`
const Right_div = styled.div`
    margin-top : 60px;
    display : inline-block;
    width : 50%;
    background : url(${Introduction_img});
    background-size : 480px 463.4292px;
    background-repeat : no-repeat;
    background-position-y : 10px;
    height : 484px;
    vertical-align : top;

`
const Title_span = styled.span`
font-family: "Title";        
    display : inline-block;
    font-size : 35px; 
    font-weight : bold;
    margin-top :70px ;
`
const Content_p = styled.p`
font-family: "Content";        
    margin : 20px 0 ; 
    font-size : 20px; 
    line-height : 40px;
    color : #212121;
`
const Wrapper_div = styled.div`
    margin : 0 10%;
`
const UL = styled.ul`
    margin : 40px 0 ;

`
const LI = styled.li`
font-family: "Table_content";        
    margin : 0;
    padding : 10px 40px;
    font-size : 20px;
    line-height : 30px;
    color : #212121;
    &:nth-child(2n){
        background:#E4F3FF;
    }
    &:nth-child(2n-1){
        background:#F9F9F9;
    }
`
const Point_span = styled.span`
    background-color :#E4F3FF;
    width : 8px; 
    height : 8px; 
    line-height : 30px;
    display : inline-block; 
    border-radius : 100%;
    vertical-align : middle;
    margin : 0 5px;
`
const IN_Span = styled.span`
    display: inline-block;
    margin : 10px 60px;
    color : #212121;
    background : white;
    padding : 5px 20px;
    border-radius : 15px;
    line-height : 30px;
`

const Table = styled.table`
margin : 30px 0 ;
font-size : 20px;

`
const Table_title= styled.span`
    font-size : 20px;
    color : #32A4FF;
    font-weight : bold;
`
const TR = styled.tr`
&:nth-child(2n){
    background : #E4F3FF;
}
&:nth-child(2n-1){
    background : #F9F9F9;
}
`
const TH = styled.th`
background : white ; 
padding : 15px;
border-left : 3px solid #F9F9F9;
border-right : 3px solid #F9F9F9;
`
const TD = styled.td`
padding : 15px;
&:nth-child(1){
    width : 200px;
    font-weight : bold;
    font-family: "Table_title";        
}
&:nth-child(2){
    width : 1000px;
    font-family: "Table_content";        
}
border-left : 3px solid #F9F9F9;
border-right : 3px solid #F9F9F9;
line-height : 30px;
`
function Introduction(){
    return (
        <Wrapper_div>
            <Left_div>
            <Title_span>Introduction</Title_span>
            <Content_p>Seoul National University Prospectively Enrolled Registry for Genitourinary Cancer (SUPER-GUC) is a set of prospective, comprehensive, multidisciplinary, bio-bank-linked cohorts based on standard real practice for prostate cancer (PC), renal cell carcinoma (RCC), and urothelial cancer (UC). The first participant was enrolled in March 7, 2016, and the total number of participant reaches over 6,000.</Content_p>
            </Left_div>
            <Right_div>
            
            </Right_div>
        </Wrapper_div>
    )
}

function Sub_cohorts(){
    return(
    <Wrapper_div>
        <Title_span>Sub cohorts</Title_span>
        <Content_p>
        SUPER-GUC consists of three cohorts based on cancer type, SUPER-PC, SUPER-RCC, and SUPER-UC. Each cohort is composed of several sub-cohorts based on treatment or disease status. Names of the sub-cohorts and their eligibility criteria are described in following Table 1.
        </Content_p>
        <div>
            <Table_title>SUPER-PC</Table_title>
            <Table>
                <TR>
                    <TH>Cohort</TH><TH>Eligibillity Criteria</TH>
                </TR>
                <TR>
                    <TD>SUPER-PC-PR</TD><TD>Pathologically proven prostate cancer patients who undergo radical prostatectomy</TD>
                </TR>
                <TR>
                    <TD>SUPER-PC-AS</TD><TD>Pathologically proven low risk prostate cancer patients within 6 months who undergo active surveillance as initial treatment. They should be eligible by strict criteria registered in Clinical Trials.gov protocol (NCT02971085), when patients want and meet usual active surveillance criteria they can be enrolled as non-strict criteria.
</TD>
                </TR>
                <TR>
                    <TD>SUPER-PC-RT</TD><TD>Pathologically proven prostate cancer patients who undergo radiation therapy with curative intent. It includes primary,
adjuvant and salvage radiation therapy, but palliative radiation therapy is not eligible.
</TD>
                </TR>
                <TR>
                    <TD>SUPER-PC-HSPC</TD><TD>Pathologically proven non-metastatic or metastatic hormone sensitive prostate cancer patients who undergo medical therapy as major initial treatment. It includes watchful waiting, ADT and chemo-ADT. Neoadjuvant or adjuvant medical therapy for other major treatment is not eligible.
</TD>
                </TR>
                <TR>
                    <TD>SUPER-PC-CRPC</TD><TD>Pathologically proven prostate cancer patients, who were progressed as CRPC within 3 months.</TD>
                </TR>
            </Table>
            <Table_title>SUPER-RCC</Table_title>
            <Table>
                <TR>
                    <TH>Cohort</TH><TH>Eligibillity Criteria</TH>
                </TR>
                <TR>
                    <TD>SUPER-RCC-Nx</TD><TD>Clinically diagnosed as renal cell carcinoma patients who undergo surgical treatment. It includes ablation, parial or radical nephrectomy. It is not limited to localized cancer, thus cytoreductive nephrectomy in metastic disease is also eligible.
</TD>
                </TR>
                <TR>
                    <TD>SUPER-RCC-mRCC</TD><TD>Pathologically proven renal cell carcinoma patients who were diagnosed as advanced (T4 or N1) or metastic disease within 3 months and undergo initail treatment for advanced or metastic RCC. Nephrectomy or metastasectomy before pathologic diagnosis does not limit the enrollment.
</TD>
                </TR>
            </Table>
            <Table_title>SUPER-UC</Table_title>
            <Table>
                <TR>
                    <TD>SUPER-UC-TURB</TD><TD>Clinically diagnosed as bladder cancer patients who undergo transurethral resection of bladder tumor.</TD>
                </TR>
                <TR>
                    <TD>SUPER-UC-Cx</TD><TD>Pathologically proven bladder cancer patients who undergo radical cystectomy.</TD>
                </TR>
                <TR>
                    <TD>SUPER-UC-UTUC</TD><TD>Clinically diagnosed as upper urinary tract urothelial cancer patients who undergo curative surgical treatment for it. It includes nephroureterectomy, segmental ureterectomy and any kind of nephron sparing endoscopic treatment. It also includes definitive treatment plan after intraoperative decision by ureteroscopy with or without frozen biopsy.</TD>
                </TR>
                <TR>
                    <TD>SUPER-PC-mUC</TD><TD>Pathologically proven urothelial cancer patients who were diagnosed as advanced (non-localized or lymph node involvement) or metastatic disease within 3 months and undergo initial treatment for advanced or metastatic urothelial cancer.
</TD>
                </TR>
            </Table>
        </div>
    </Wrapper_div>
    )
}

function Major_goals(){
    return(
        <Wrapper_div>
            <Title_span>Major goals</Title_span>
            <Content_p>The major goals of the SUPER-GUC are as follows.</Content_p>
            <UL>
                <LI> To conduct comparative outcome studies between various treatment options</LI>
                <LI> To identify prognostic factors for disease progression and mortality</LI>
                <LI> To facilitate various type of translational research including genetic or molecular profiling  <br/>and biomarker studies</LI>
                <LI> To understand patients’ quality of life (QoL) and promote QoL research including a  <br/>
                patient-oriented outcome study and comparative-effectiveness research </LI>
                <LI> To investigate changes in body composition and its impacts on outcomes</LI>
                <LI> To understand the influence of aging and fragility on treatment and cancer in elderly patients</LI>
            </UL>
        </Wrapper_div>
    )
}

function Collecting_data_and_bio_specimen(){
    return(
        <Wrapper_div>
            <Title_span>Collecting data and bio-specimen</Title_span>
            <Content_p>All data were collected using the Research Electronic Data Capture (REDCap) system in an independent server with a triple back-up system.</Content_p>
            <UL>
                <LI> Demographics, baseline cancer characteristics, medication, treatment, biorepository information</LI>
                <LI> Imaging, pathologic results</LI>
                <LI> Oncologic outcomes, survival (annually updated with death registry at the Statistics Korea)</LI>
                <LI> Surgical complication (revised Clavien-Dindo classification), treatment-related adverse events (CTCAE grade)</LI>
                <LI> Bioelectrical impedance analysis (BIA, using InBody 570)(baseline and periodic follow-up)</LI>
                <LI> <Title_span_T>Quality of life questionnaires (baseline and periodic follow-up)</Title_span_T><br/>
                <IN_Span>
                - Common: EQ-5D-5L<br/>
                - Prostate cancer: IPSS, IIEF-5, EPIC-CP<br/>
                - Renal cell carcinoma: FKSI-15<br/>
                - Bladder cancer (cystectomy): FACT-VCI<br/>
                - Participant who undergo major surgery: CARE (Convalescence And Recovery Evaluation)<br/>
                - Participant who are 65 years or older: G8 geriatric screening<br/>
                </IN_Span>
                </LI>
                <LI><Title_span_T>Bio-specimen</Title_span_T><br/>
                <IN_Span>
                - Formalin-fixed, paraffin-embedded tissue block<br/>
                - Freshly frozen tumor and normal tissues (Liquid nitrogen, Seoul National University Cancer Tissue Bank)<br/>
                - Pretreatment whole blood, serum buffy coat, plasma, and urine <br/>(Deep freezer or Liquid nitrogen, Seoul National University Hospital Human Biobank)<br/>
                </IN_Span>
                </LI>
            </UL>
        </Wrapper_div>
    )
}
const Title_span_T = styled.span`
font-weight: bold;
color: #212121;
`
function Super_GUC(){
    return (
        <Wrapper>
            <Slide imgURL={SUPER_GUC_IMG} inputText="SUPER GUC"/>
            <Introduction/>
            <Sub_cohorts/>
            <Major_goals/>
            <Collecting_data_and_bio_specimen/>

        </Wrapper>
    )
}  

const Crow_img1 = styled.img`
width : 100px; 
height : 212.121px;
position : absolute;
top:150px;
right :10px;
`
const Crow_img2 = styled.img`
width : 100px; 
height : 93.419px;
position : absolute;
top:740px;
left : 100px;
`
const Crow_img3 = styled.img`
width : 200px; 
height : 118.57px;
position : absolute;
top:2550px;
right : 50px;
transform: rotate3d(0.2, 1, 0, 180deg);


`
const Wrapper = styled.div`
font-family: "En";        
position : relative; 
top : 90px;
width : 1200px; 
margin : 0 auto; 
`

export default Super_GUC;